import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { HelmetProvider } from "react-helmet-async";
import Helmet from "./components/Helmet";
import Layout from "./components/Layout";
import Calculator from "./pages/Calculator";
import theme from "./theme";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <CssBaseline />

        <Helmet
          title="freem | Bußgeldrechner"
          content="freem | Bußgeldrechner"
          keyword="freem | Bußgeldrechner"
        />

        <Router>
          <Layout>
            <Switch>
              <Route path="/" component={Calculator} />

              <Route path="*">
                <Redirect to="/" />
              </Route>
            </Switch>
          </Layout>
        </Router>
      </HelmetProvider>
    </ThemeProvider>
  );
};

export default App;
